'use client';

import NotFound from '@actr/widgets/src/components/_misc/not-found';
import React from 'react';

import * as Styled from './style.css';

const NotFoundComponent = () => (
  <div className={Styled.Container}>
    <NotFound />
  </div>
);

export default NotFoundComponent;
